import React from 'react';
import './QuestionSlide.css'
import QuizAnswer from '../../Common/QuizAnswer/QuizAnswer';
import { SlideAnswerData, SlideQuestionData } from '../../../models/Quiz';

interface QuestionSlideProps {
  slideData: SlideQuestionData
  showError: boolean
  selectAnswer: (questionId: number, answerId: number) => void
  nextSlide: () => void
}

function QuestionSlide({slideData, showError, selectAnswer, nextSlide}: QuestionSlideProps) {

  const handleSelect = (id: number) => {
      selectAnswer(slideData.questionId, id)
  }

  return (
    <div className="question-slide slide">
      <div className='question-text-container'>
        <h3>{slideData.questionText}</h3>
      </div>
      <div className='answer-container'>
        {slideData.answers.map((answer: SlideAnswerData, i: number) => (
        <QuizAnswer answer={answer} selected={answer.selected} handleSelect={handleSelect} key={`${slideData.questionId}-${i}`} />
      ))}
      </div>
        <button className='button' onClick={nextSlide}>Next</button>
        <p className='quiz-error-message'>{showError && "Please select an answer."}</p>
    </div>
  );
};

export default QuestionSlide;